<template>
  <div>
    <v-combobox
      v-model="selectedCustomer"
      :search-input.sync="search"
      label="Customer"
      color="secondary"
      :items="customers"
      item-text="mapName"
      item-value="number"
      :rules="[
        (v) => !!v || 'Field is require.'
      ]"
      :loading="loading"
      dense
      @input="onSelectCustomer($event)">
      <template #item="{ item }">
        <span style="font-size: 13px; color: rgba(0, 0, 0, 0.87); font-weight: 500;">
          {{ `${item.number} - ${item.searchName}` }}
        </span>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import CustomersProvider from '@/resources/CustomersProvider'
import ShippingCountries from '@/assets/json/ShippingCountries.json'

const CustomersService = new CustomersProvider()

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    heightOffset: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      loading: true,
      customers: [],
      search: '',
      searchTimeout: null
    }
  },
  computed: {
    selectedCustomer: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    search () {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => this.fetchCustomers(), 500)
    }
  },
  methods: {
    async fetchCustomers () {
      try {
        this.loading = true

        const { data } = await CustomersService.getItems({
          page: 1,
          limit: 50,
          search: this.search
        })
        const reducedCountries = ShippingCountries.reduce((acc, country) => {
          acc[country.code] = country

          return acc
        }, {})
        const mapped = data.results.map((item) => {
          const country = reducedCountries[item.countryLetterCode]

          return {
            ...item,
            mapName: `${item.number} - ${item.searchName}`,
            country: country?.country || item.countryLetterCode
          }
        })

        this.customers = mapped
      } catch (error) {
        console.error('fetchCustomers', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    onSelectCustomer (item) {
      const address = {
        address: item.address,
        address2: item.address2,
        subDistrict: item.subDistrict,
        district: item.city,
        stateProvince: item.county,
        country: item.country,
        postcode: item.postalCode,
        note: '',
        contactNo: item.phoneNumber,
        email: item.email,
        firstName: item.name,
        lastName: item.name2 || ' ',
        taxId: item.taxRegistrationNumber,
        customerId: item.number
      }

      this.$emit('select-customer', address)
    }
  }
}
</script>

<style scoped>

</style>
